import {connectToStores} from 'epic-alt-utils';
import {generateRouteHref} from '../../utils/route';
import epicTracking from 'epic-tracking';
import PropTypes from 'prop-types';
import React from 'react';
import {withRouter} from 'react-router';

import LoginActions from '../../actions/LoginActions';
import AppConfigStore from '../../stores/AppConfigStore';
import LoginStore from '../../stores/LoginStore';
import Message from '../message/Message';

import DownloadSelection from './DownloadSelection';

@connectToStores
class LoginOverlay extends React.Component {
  static propTypes = {
    loginStore: PropTypes.object,
    location: PropTypes.object,
    appConfigStore: PropTypes.object,
  };

  state = {
    playFortnite: true,
    errorOut: true,
    answeredNo: false,
  };

  static getStores() {
    return [LoginStore, AppConfigStore];
  }

  static getPropsFromStores() {
    return {
      loginStore: LoginStore.getState(),
      appConfigStore: AppConfigStore.getState(),
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    const {loginModal} = this.props.loginStore;
    const oldLoginModal = prevProps.loginStore.loginModal;
    const {playFortnite} = this.state;
    const oldPlayFortnite = prevState.playFortnite;
    if ((!oldLoginModal && loginModal) || playFortnite !== oldPlayFortnite) {
      this.enterAnimation();
    }
  };

  trackEvent = (eventAction, data = {}) => {
    epicTracking.trackEvent('Interaction', {
      interactionType: 'click',
      eventCategory: 'LoginOverlay',
      eventAction,
      ...data,
    });
  };

  enterAnimation = () => {
    const overlay = this.overlayContainer;
    TweenMax.fromTo(
      overlay,
      0.7,
      {y: 50, autoAlpha: 0},
      {
        y: 0,
        autoAlpha: 1,
        ease: Elastic.easeOut.config(1, 0.5),
        clearProps: 'all',
      }
    );
  };
  nextAnimation = (cb) => {
    const overlay = this.overlayContainer;
    TweenMax.fromTo(
      overlay,
      0.2,
      {y: 0, autoAlpha: 1},
      {
        y: 50,
        autoAlpha: 0,
        ease: Power3.easeIn,
        onComplete: cb,
      }
    );
  };
  showNextScreen = () => {
    this.nextAnimation(this.showNextComplete);
  };
  showAnswerNoScreen = () => {
    this.nextAnimation(() =>
      this.setState({playFortnite: false, errorOut: false, answeredNo: true})
    );
  };
  showNextComplete = () => {
    this.setState({playFortnite: false, errorOut: false});
  };
  close = () => {
    TweenMax.to(this.overlay, 0.5, {
      autoAlpha: 0,
      ease: Power3.easeOut,
      onComplete: this.fadeComplete,
    });
    this.setState({playFortnite: true, errorOut: true, answeredNo: false});
  };
  fadeComplete = () => {
    LoginActions.closeLoginModal();
  };
  getReturnPath = () => {
    const {location} = this.props;
    let returnPath;
    if (this.props.loginStore.loginModalReturn) {
      returnPath = generateRouteHref(this.props.loginStore.loginModalReturn, location);
    } else {
      returnPath = this.props.location.pathname;
    }
    return returnPath;
  };
  answerNo = () => {
    const {
      loginStore: {answerNoContent},
    } = this.props;
    if (answerNoContent) {
      this.showAnswerNoScreen();
    } else {
      this.signUp();
    }
  };
  signUp = () => {
    this.trackEvent('signUp');
    LoginActions.requestRegister({returnPath: this.getReturnPath()});
  };
  signIn = () => {
    LoginActions.requestLogin({returnPath: this.getReturnPath()});
  };
  signInPC = () => {
    this.trackEvent('signInPC');
    this.signIn();
  };
  signInMobile = () => {
    this.trackEvent('signInMobile');
    this.signIn();
  };
  signInXBox = () => {
    this.trackEvent('signInXBox');
    LoginActions.requestLoginXBox({returnPath: this.getReturnPath(), skipReg: true});
  };
  signInPSN = () => {
    this.trackEvent('signInPSN');
    LoginActions.requestLoginPSN({returnPath: this.getReturnPath(), skipReg: true});
  };
  signInNintendo = () => {
    this.trackEvent('signInNintendo');
    LoginActions.requestLoginNintendo({returnPath: this.getReturnPath(), skipReg: true});
  };
  render() {
    let overlayContent;
    const {
      loginStore: {loginModal, errorModal, downloadModal, answerNoContent},
      appConfigStore: {countryCode},
      appConfigStore,
      location: {pathname},
    } = this.props;
    if (!errorModal && !loginModal) {
      return <div />;
    }
    const ios = pathname.indexOf('/android') !== -1;

    if (downloadModal) {
      overlayContent = (
        <DownloadSelection
          onAndroidPage={ios}
          appConfigStore={appConfigStore}
          countryCode={countryCode}
        />
      );
    } else if (errorModal && this.state.errorOut) {
      const showNextScreen = () => {
        this.trackEvent('FnMobile-overlayErrorSignIn');
        this.showNextScreen();
      };
      const signUp = () => {
        this.trackEvent('nMobile-overlayErrorSignUp');
        this.signUp();
      };
      overlayContent = (
        <div className="content-error">
          <h2>
            <Message code="epic.fortnite.mobile.noAccount" />
          </h2>
          <button
            id="FnMobile-overlayErrorSignIn"
            className="btn btn-primary"
            onClick={showNextScreen}>
            <Message code="epic.common.accountportal.default.sign_in" />
          </button>
          <button id="FnMobile-overlayErrorSignUp" className="btn btn-primary" onClick={signUp}>
            <Message code="epic.common.accountportal.default.register" />
          </button>
        </div>
      );
    } else if (this.state.playFortnite) {
      const showNextScreen = () => {
        this.trackEvent('FnMobile-overlaySignIn');
        this.showNextScreen();
      };
      const answerNo = () => {
        this.trackEvent('FnMobile-overlaySignUp');
        this.answerNo();
      };
      overlayContent = (
        <div className="content-question">
          <h2>
            <Message code="epic.fortnite.mobile.playedBefore" />
          </h2>
          <p>
            <Message code="epic.fortnite.mobile.findDescription" />
          </p>
          <button id="FnMobile-overlaySignIn" className="btn btn-primary" onClick={showNextScreen}>
            <Message code="epic.fortnite.mobile.answerYes" />
          </button>
          <button id="FnMobile-overlaySignUp" className="btn btn-primary" onClick={answerNo}>
            <Message code="epic.fortnite.mobile.answerNo" />
          </button>
        </div>
      );
    } else if (answerNoContent && this.state.answeredNo) {
      const close = () => {
        this.trackEvent('close-customized-answer-no');
        this.close();
      };
      overlayContent = (
        <div className="content-error customized-answer-no">
          <div dangerouslySetInnerHTML={{__html: answerNoContent}} />
          <button id="FnMobile-overlayErrorSignUp" className="btn btn-primary" onClick={close}>
            <Message code="epic.common.back" />
          </button>
        </div>
      );
    } else {
      overlayContent = (
        <div className="content-selection">
          <h2>
            <Message code="epic.fortnite.mobile.playFortniteOn" />
          </h2>
          <div className="btn-container">
            <button id="fnMobile-Ps4" className="btn btn-primary" onClick={this.signInPSN}>
              <i className="icon-ps4" />
              <Message code="epic.fortnite.mobile.signIn.ps4" />
            </button>
            <button id="fnMobile-Xbox" className="btn btn-primary" onClick={this.signInXBox}>
              <i className="icon-xbox" />
              <Message code="epic.fortnite.mobile.signIn.xbox" />
            </button>
            <button id="fnMobile-switch" className="btn btn-primary" onClick={this.signInNintendo}>
              <i className="icon-nintendo" />
              <Message code="epic.fortnite.mobile.signIn.switch" />
            </button>
            <button id="fnMobile-PC" className="btn btn-primary" onClick={this.signInPC}>
              <i className="icon-pc" />
              <Message code="epic.fortnite.mobile.signIn.newPc" />
            </button>
            <button id="fnMobile-mobile" className="btn btn-primary" onClick={this.signInMobile}>
              <i className="icon-mobile" />
              {ios ? (
                <Message code="epic.fortnite.overlay.ios" />
              ) : (
                <Message code="epic.fortnite.mobile.signIn.mobile" />
              )}
            </button>
          </div>
        </div>
      );
    }

    const close = () => {
      this.trackEvent('overlayCloseBtn');
      this.close();
    };

    return (
      <div className="fn-mobile-overlay-container">
        <div
          ref={(c) => {
            this.overlay = c;
          }}
          role="presentation"
          className="fn-mobile-overlay theEnd-background-color">
          <div className="bkgrd" />
          <div className="overlay-container text-center">
            <div className="col-xs-12 text-right theEnd-all-children-background-color">
              <button id="overlayCloseBtn" className="close-button" onClick={close}>
                <i className="icon-x" />
              </button>
            </div>
            <div
              ref={(c) => {
                this.overlayContainer = c;
              }}
              className="animateContainer">
              <div>{overlayContent}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(LoginOverlay);
